import * as React from "react";
import { ExecuteSearchAsync } from "source/app/presentation/MainPanel/Workflows/SearchNodes/Update/ExecuteSearch";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";

export function SearchNodesLink({ searchText }: { searchText: string }) {
    const shouldReduceOpacity = searchText === "";

    return (
        <IconWithText
            iconSuffix={EGlyphicon.search}
            whenClicked={async () => await ExecuteSearchAsync()}
            displayAsBlock={false}
            withClass={StyleClass(
                `searchWorkflowNodes_${shouldReduceOpacity}`,
                {
                    margin: 0,
                    position: `relative`,
                    bottom: `7px`,
                    opacity: shouldReduceOpacity ? 0.3 : 1.0,
                }
            )}
        >
            Search
        </IconWithText>
    );
}
